<template>
  <custom-select
    v-model="getEjercicio"
    :items="ejercicios"
    :label="label">
  </custom-select>
</template>

<script>
import CustomSelect from './sinColumnas/Select.vue';

export default {
  name: 'EjercicioPicker',
  props: {
    value: {
      type: Number,
      required: false,
      default() {
        const hoy = new Date();
        return hoy.getFullYear();
      },
    },
    label: {
      type: String,
      required: false,
      default: 'Ejercicio',
    },
  },
  components: {
    CustomSelect,
  },
  data() {
    return {
      hoy: new Date(),
    };
  },
  computed: {
    ejercicios() {
      const esteEjercicio = this.hoy.getFullYear();
      return this.$range((2020), (esteEjercicio + 2)).reverse();
    },
    getEjercicio: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
